import HostedReportGroupView from './HostedReportGroupView'

export default HostedReportGroupView
